<template>
  <v-dialog :value="true" max-width="650" scrollable @input="$emit('close')">
    <v-card>
      <v-card-title>{{ tag.name }}</v-card-title>
      <v-card-subtitle class="pt-1">{{ tag.tagged }} con la etiqueta, en {{ obligation.name }}</v-card-subtitle>
      <v-card-text>
        <v-progress-linear v-if="loading" indeterminate class="mb-2" />
        <v-alert v-if="errorMessage" type="error" dense text>{{ errorMessage }}</v-alert>
        <div v-for="group in groups" :key="group.obligation" class="tag-detail__group">
          <div class="subtitle-2">{{ group.obligation }}</div>
          <div v-for="list in listsOf(group)" :key="list.title" class="mt-2">
            <div class="caption grey--text text--darken-1">{{ list.title }} ({{ list.lines.length }})</div>
            <div v-if="!list.lines.length" class="body-2 grey--text">Ninguna</div>
            <div v-for="(line, index) in list.lines" :key="index" class="body-2">
              {{ line.contractor }}<template v-if="line.reference">: {{ line.reference }}</template>
              <span v-if="line.company" class="caption grey--text ml-1">{{ line.company }}</span>
            </div>
          </div>
        </div>
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn @click="$emit('close')">Cerrar</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
"use strict";

import obligationService from "@/services/ObligationService";

// Solo lectura: abre desde el ojo de "Propagar etiquetas".
export default {
  name: "tag-propagation-detail",
  props: {
    obligation: { type: Object, required: true },
    tag: { type: Object, required: true }
  },
  data() {
    return { groups: [], loading: false, errorMessage: null };
  },
  async mounted() {
    this.loading = true;
    try {
      this.groups = await obligationService.getTagPropagationDetail(this.obligation._id, this.tag._id);
    } catch (error) {
      this.errorMessage = "No se pudo cargar el detalle";
    } finally {
      this.loading = false;
    }
  },
  methods: {
    listsOf(group) {
      return [
        { title: "Con la etiqueta", lines: group.withTag },
        { title: "Sin la etiqueta", lines: group.withoutTag }
      ];
    }
  }
};
</script>

<style lang="scss">
.tag-detail__group + .tag-detail__group {
  margin-top: 20px;
}
</style>
